import footerCopyrightInit from './footer-copyright/footer-copyright.js'
import { applyBrandColor } from './utils/brand-color.js'
import { getLogoMainText, shouldShowHeaderSlots } from './common-header/config.js'
const LOG_PREFIX = '[new-experience-portal]'

const commonHeaderInit = () => import('./common-header/common-header.js')

function getWebPortalSettings() {
  if (!shouldShowHeaderSlots(getLogoMainText(window.microsDatas || {}))) {
    return null
  }
  const raw = window.microsDatas?.webPortalSettings
  if (raw == null) return null
  if (typeof raw === 'string') {
    const trimmed = raw.trim()
    if (!trimmed) return null
    try {
      const parsed = JSON.parse(trimmed)
      return parsed && typeof parsed === 'object' ? parsed : null
    } catch (e) {
      console.warn(`${LOG_PREFIX} webPortalSettings JSON parse failed:`, e)
      return null
    }
  }
  if (typeof raw === 'object') {
    return Object.keys(raw).length ? raw : null
  }
  return null
}

export default async function initNewExperiencePortal() {
  const settings = getWebPortalSettings()

  if (settings?.general?.style?.brandColor) {
    applyBrandColor(settings.general.style.brandColor)
  }

  const headerModule = await commonHeaderInit()
  headerModule.default(settings?.header)
  footerCopyrightInit(settings?.footer)
}
